/* styles.compiled.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._0aFT5vbt8w%7Bflex-direction%3Acolumn%7D%0A._37wbyuDIqT%7Bjustify-content%3Acenter%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D%0A._2fwxA5DIqT%7Btext-align%3Acenter%7D%0A._1zQR5N1Y8M%20p%7Bmargin-block%3Avar(--ds-space-050%2C4px)%7D%0A._1Zs0f8dnbC%20p%7Bmargin-inline%3A0%7D%0A._1tJeXfN91d%20img%7Bwidth%3A100%25%7D");







import { type CSSProperties, type ReactNode } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const errorContainerStyles = {
  base: "_3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _39xV02N91d _2fwxA5DIqT _1zQR5N1Y8M _1Zs0f8dnbC _1tJeXfN91d"
};
export function ErrorContainer({
  children,
  isFullPage,
  imageMaxWidthPx,
  'data-testid': testId
}: {
  children?: ReactNode;
  isFullPage: boolean;
  imageMaxWidthPx?: string;
  'data-testid'?: string;
}): JSX.Element {
  return <div data-testid={testId}
  /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ style={({
    height: isFullPage ? 'calc(100vh - 120px)' : undefined,
    minHeight: isFullPage ? '400px' : undefined,
    '--error-img-max-width': imageMaxWidthPx ?? '164px'
  } as CSSProperties)}
  /* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */ className={ax([errorContainerStyles.base])}>
			{children}
		</div>;
}